var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.25 0C39.862 0 26.0633 5.71561 15.8895 15.8895C5.71561 26.0633 0 39.862 0 54.25C0 68.638 5.71561 82.4367 15.8895 92.6105C26.0633 102.784 39.862 108.5 54.25 108.5C68.638 108.5 82.4367 102.784 92.6105 92.6105C102.784 82.4367 108.5 68.638 108.5 54.25C108.5 39.862 102.784 26.0633 92.6105 15.8895C82.4367 5.71561 68.638 0 54.25 0ZM23.25 50.375V58.125H85.25V50.375H23.25Z",
    fill: "#F01919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAdmin);
export default __webpack_public_path__ + "static/media/RemoveAdmin.f892d5722105f696a9feb7cab6009f12.svg";
export { ForwardRef as ReactComponent };